import React, { useEffect, useMemo, useState } from "react";
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner,
  Input, Alert, Label, FormGroup, Badge, Row, Col,
} from "reactstrap";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const KATEGORI_HAKLARI = [
  { key: "ILAN", label: "İlan Hakkı" },
  { key: "MEZAT", label: "Mezat Hakkı" },
  { key: "MEZAT_UZATMA", label: "Mezat Uzatma Hakkı" },
  { key: "DEGERLEME", label: "Değerleme Hakkı" },
];

const KOZMETIK_HAKLARI = [
  { key: "MEZAT_DENEME", label: "Mezat Deneme Hakkı" },
  { key: "VITRIN", label: "Vitrin Hakkı" },
  { key: "MODERATOR", label: "Moderatör Hakkı" },
  { key: "KALIN_YAZI", label: "Kalın Yazı Hakkı" },
  { key: "CERCEVE", label: "Çerçeve Hakkı" },
];

const KOZMETIK_KEYS = KOZMETIK_HAKLARI.map((h) => h.key);

/**
 * Toplu hak verme — seçili kullanıcılara veya tüm aktif kullanıcılara
 * tek seferde hak ekler/düşürür.
 *
 * Kategori bazlı haklarda kategori seçilmezse TÜM ana kategorilere uygulanır.
 * Kozmetik haklarda kategori kavramı yoktur, seçim gizlenir.
 *
 * Uç: POST /api/AdminHak/Toplu
 */
const TopluHakModal = ({ isOpen, toggle, secilenKullanicilar = [], headers, onDone }) => {
  const [hakTipi, setHakTipi] = useState("MEZAT");
  const [miktar, setMiktar] = useState(1);
  const [kategoriId, setKategoriId] = useState("");
  const [kategoriler, setKategoriler] = useState([]);
  const [tumKullanicilar, setTumKullanicilar] = useState(false);
  const [aciklama, setAciklama] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [hata, setHata] = useState(null);
  const [sonuc, setSonuc] = useState(null);

  const kozmetikMi = KOZMETIK_KEYS.includes(hakTipi);

  useEffect(() => {
    if (!isOpen) return;
    setHata(null);
    setSonuc(null);
    setAciklama("");
    setMiktar(1);
    setTumKullanicilar(false);

    // Ana kategoriler (üst bağlantısı olmayanlar) — haklar ana kategoride tutulur.
    (async () => {
      try {
        const [rKat, rBag] = await Promise.all([
          fetch(`${BASE_URL}/KATEGORILER?$select=ID,AD&$orderby=SIRA_NO asc`, { headers }),
          fetch(`${BASE_URL}/KATEGORI_BAGLANTILARI?$select=ALT_KATEGORI_ID&$top=10000`, { headers }),
        ]);
        const kat = (await rKat.json()).value || [];
        const bag = (await rBag.json()).value || [];
        const altIds = new Set(bag.map((b) => b.ALT_KATEGORI_ID));
        setKategoriler(kat.filter((k) => !altIds.has(k.ID)));
      } catch {
        // kategori çekilemezse "tüm kategoriler" seçeneğiyle devam edilebilir
      }
    })();
  }, [isOpen, headers]);

  const hedefSayisi = tumKullanicilar ? null : secilenKullanicilar.length;

  const uygulanabilir = useMemo(() => {
    if (Number(miktar) === 0) return false;
    if (!tumKullanicilar && secilenKullanicilar.length === 0) return false;
    return true;
  }, [miktar, tumKullanicilar, secilenKullanicilar]);

  const uygula = async () => {
    const m = Math.trunc(Number(miktar) || 0);
    if (m === 0) { setHata("Miktar 0 olamaz."); return; }

    const kimeMetin = tumKullanicilar
      ? "TÜM AKTİF KULLANICILARA"
      : `${secilenKullanicilar.length} kullanıcıya`;
    const islem = m > 0 ? `+${m} eklenecek` : `${m} düşülecek`;
    if (!window.confirm(`${kimeMetin} ${islem}.\n\nDevam edilsin mi?`)) return;

    setIsSaving(true);
    setHata(null);
    setSonuc(null);
    try {
      const res = await fetch(`${BASE_URL}/api/AdminHak/Toplu`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          KullaniciIdler: tumKullanicilar ? null : secilenKullanicilar.map((u) => u.ID),
          TumKullanicilar: tumKullanicilar,
          HakTipi: hakTipi,
          Miktar: m,
          KategoriId: kozmetikMi || !kategoriId ? null : Number(kategoriId),
          Aciklama: aciklama || null,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.basarili) {
        setHata(data.message || data.Message || "Toplu işlem başarısız.");
        return;
      }
      setSonuc(data);
      if (onDone) onDone(data);
    } catch {
      setHata("Toplu işlem sırasında hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>
        <i className="mdi mdi-account-multiple-plus-outline me-2 text-primary" />
        Toplu Hak Ver
      </ModalHeader>

      <ModalBody>
        {hata && <Alert color="danger" toggle={() => setHata(null)}>{hata}</Alert>}
        {sonuc && (
          <Alert color="success">
            <i className="mdi mdi-check-circle me-1" />
            {sonuc.mesaj}
          </Alert>
        )}

        <Alert color={tumKullanicilar ? "warning" : "light"} className="py-2">
          {tumKullanicilar ? (
            <>
              <strong>Dikkat:</strong> İşlem <strong>tüm aktif kullanıcılara</strong> uygulanacak.
              Pasif ve silinmiş hesaplar hariç tutulur.
            </>
          ) : secilenKullanicilar.length === 0 ? (
            <>Listeden kullanıcı seçin veya aşağıdan &quot;tüm aktif kullanıcılar&quot;ı işaretleyin.</>
          ) : (
            <>
              Hedef: <Badge color="primary">{secilenKullanicilar.length} kullanıcı</Badge>{" "}
              <small className="text-muted">
                {secilenKullanicilar.slice(0, 4).map((u) => u.AD_SOYAD || `#${u.ID}`).join(", ")}
                {secilenKullanicilar.length > 4 ? ` +${secilenKullanicilar.length - 4} kişi` : ""}
              </small>
            </>
          )}
        </Alert>

        <FormGroup check className="mb-3">
          <Input type="checkbox" id="tumKullanicilar" checked={tumKullanicilar}
            onChange={(e) => setTumKullanicilar(e.target.checked)} />
          <Label check for="tumKullanicilar" className="fw-bold">
            Tüm aktif kullanıcılara uygula
          </Label>
        </FormGroup>

        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-bold">Hak Türü</Label>
              <Input type="select" value={hakTipi} onChange={(e) => setHakTipi(e.target.value)}>
                <optgroup label="Kategori Bazlı Haklar">
                  {KATEGORI_HAKLARI.map((h) => (
                    <option key={h.key} value={h.key}>{h.label}</option>
                  ))}
                </optgroup>
                <optgroup label="Ekstra / Kozmetik Haklar">
                  {KOZMETIK_HAKLARI.map((h) => (
                    <option key={h.key} value={h.key}>{h.label}</option>
                  ))}
                </optgroup>
              </Input>
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label className="fw-bold">Miktar</Label>
              <Input type="number" value={miktar}
                onChange={(e) => setMiktar(e.target.value)} />
              <small className="text-muted">
                Negatif değer girerek toplu düşüm yapabilirsiniz (sonuç 0&apos;ın altına inmez).
              </small>
            </FormGroup>
          </Col>

          {!kozmetikMi && (
            <Col md={12}>
              <FormGroup>
                <Label className="fw-bold">Kategori</Label>
                <Input type="select" value={kategoriId}
                  onChange={(e) => setKategoriId(e.target.value)}>
                  <option value="">— Tüm ana kategoriler —</option>
                  {kategoriler.map((k) => (
                    <option key={k.ID} value={k.ID}>{k.AD}</option>
                  ))}
                </Input>
                <small className="text-muted">
                  Boş bırakırsanız hak, kullanıcının tüm ana kategorilerine eklenir.
                </small>
              </FormGroup>
            </Col>
          )}

          <Col md={12}>
            <FormGroup>
              <Label className="fw-bold">
                Açıklama <span className="text-muted fw-normal">(hak geçmişine yazılır)</span>
              </Label>
              <Input type="text" maxLength={500}
                placeholder="ör. Kurban Bayramı kampanyası, sistem arızası telafisi"
                value={aciklama} onChange={(e) => setAciklama(e.target.value)} />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" outline onClick={toggle} disabled={isSaving}>Kapat</Button>
        <Button color="primary" onClick={uygula} disabled={isSaving || !uygulanabilir}>
          {isSaving ? <Spinner size="sm" className="me-1" /> : <i className="mdi mdi-check me-1" />}
          Uygula{hedefSayisi != null ? ` (${hedefSayisi})` : ""}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TopluHakModal;
